<aside class="panel-left ${calendar.filterPanelOpen ? 'is-open' : ''}">
  <div class="filter-group">
    <div class="filter-group__header">
      <label class="filter-group__label" for="search-input">Search</label>
      <button
        type="button"
        class="panel-close"
        click.trigger="calendar.closeFilterPanel()"
        aria-label="Close filters"><span class="icon icon--close" aria-hidden="true"></span></button>
    </div>
    <div class="filter-search-row">
      <div class="filter-search-wrap">
        <input id="search-input" type="text" class="filter-search" placeholder="Brand, toy line, or note…" value.bind="calendar.searchText & debounce:300" />
        <button if.bind="calendar.searchText" type="button" class="filter-search__clear" click.trigger="calendar.clearSearch()" title="Clear search"><span class="icon icon--close" aria-hidden="true"></span></button>
      </div>
      <button
        type="button"
        class="filter-search-action"
        click.trigger="savedSearch.openSaveSearch()"
        disabled.bind="!calendar.searchText.trim()"
        title="Save current search"
        aria-label="Save current search"><span class="icon icon--save" aria-hidden="true"></span></button>
      <div class="filter-search-load">
        <button
          type="button"
          class="filter-search-action ${savedSearch.savedSearchMenuOpen ? 'active' : ''}"
          click.trigger="savedSearch.toggleSavedSearchMenu()"
          title="Load a saved search"
          aria-label="Load a saved search"
          aria-haspopup="true"
          aria-expanded.bind="savedSearch.savedSearchMenuOpen"><span class="icon icon--folder" aria-hidden="true"></span></button>
        <div if.bind="savedSearch.savedSearchMenuOpen" class="saved-search-menu__backdrop" click.trigger="savedSearch.closeSavedSearchMenu()"></div>
        <div if.bind="savedSearch.savedSearchMenuOpen" class="saved-search-menu__dropdown">
          <p if.bind="account.isAuthenticated && savedSearch.savedSearchLimit" class="saved-search__hint">
            ${savedSearch.savedSearches.length} / ${savedSearch.savedSearchLimit} saved
          </p>
          <p if.bind="savedSearch.savedSearches.length === 0" class="saved-search__empty">No saved searches yet.</p>
          <div if.bind="savedSearch.savedSearches.length" class="saved-search__list">
            <div repeat.for="search of savedSearch.savedSearches" class="saved-search__item">
              <button
                type="button"
                class="saved-search__load"
                click.trigger="savedSearch.applySavedSearch(search)"
                title="Load this search">${search.name}</button>
              <button
                if.bind="account.isAuthenticated && search.id"
                type="button"
                class="saved-search__bell ${(subscriptions.isSavedSearchSubscribed(search) ? 'is-active' : '') & signal:'subscriptions-changed'}"
                click.trigger="subscriptions.toggleSavedSearchSubscription(search)"
                disabled.bind="subscriptions.isSubscriptionPending(search.id + '') & signal:'subscriptions-changed'"
                title.bind="(subscriptions.isSavedSearchSubscribed(search) ? 'Turn off email alerts for this search' : 'Email me new matches for this search') & signal:'subscriptions-changed'"
                aria-label="Toggle email alerts for this saved search"
                aria-pressed.bind="subscriptions.isSavedSearchSubscribed(search) & signal:'subscriptions-changed'"><span class="icon ${(subscriptions.isSavedSearchSubscribed(search) ? 'icon--bell-filled' : 'icon--bell') & signal:'subscriptions-changed'}" aria-hidden="true"></span></button>
              <button
                type="button"
                class="saved-search__delete"
                click.trigger="savedSearch.deleteSavedSearch(search)"
                disabled.bind="savedSearch.deletingSearchId !== null"
                aria-label="Delete saved search"><span if.bind="savedSearch.deletingSearchId === search.id" class="spinner-ring" aria-hidden="true"></span><span if.bind="savedSearch.deletingSearchId !== search.id" class="icon icon--close" aria-hidden="true"></span></button>
            </div>
          </div>
          <p if.bind="savedSearch.savedSearchError" class="saved-search__error">${savedSearch.savedSearchError}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="filter-group filter-group--sources">
    <div class="filter-group__header">
      <span class="filter-group__label">Sources</span>
      <div class="filter-group__actions">
        <button class="filter-action" click.trigger="calendar.selectAllSources()">All</button>
        <button class="filter-action" click.trigger="calendar.clearAllSources()">None</button>
      </div>
    </div>
    <div class="filter-checklist">
      <label repeat.for="source of calendar.sourceFilters" class="filter-check">
        <input type="checkbox" checked.bind="source.active" change.trigger="calendar.toggleSource(source, $event)" />
        <span class="filter-check__label">${source.name}</span>
      </label>
    </div>
  </div>
</aside>
